import elasticSearchQuery from '@strix/search/graphql/query/elasticSearch.graphql'
import { types } from './types'

export const actions = {
  async getSearchResults ({ state, commit }, payload) {
    try {
      const cleanedQuery = payload.query.replace(/[-+~//\\<>"':*$#@()!,.?=%&^`\s]/g, '')

      if (cleanedQuery.length < 3) {
        throw new Error('Search query must be at least 3 characters long')
      }

      if (payload.size) {
        commit(types.SET_PER_PAGE, payload.size)
      }

      commit(types.IS_PENDING, true)

      await this.$graphql({
        requestPayload: {
          mutation: elasticSearchQuery,
          variables: {
            search: payload.query,
            currentPage: payload.page,
            sort: payload.sort,
            filter: payload.filter,
          },
          errorPolicy: 'ignore',
        },
        successHandler: ({ data: { amBlogPostsSearch, categoriesV2, products } }) => {
          commit(types.SET_AGGREGATIONS, products.aggregations)
          commit(types.SET_PRODUCTS, products.items)
          commit(types.SET_CATEGORY, categoriesV2.items)
          commit(types.SET_PRODUCT_TOTAL_COUNT, products.totalCount)
          commit(types.SET_PRODUCT_TOTAL_PAGES, products.pageInfo.totalPages)
          commit(types.SET_QUERY, payload.query)
          commit(types.SET_ARTICLES, amBlogPostsSearch.items)
          commit(types.SET_PRODUCTS_SORT, products.sortFields)
        },
      })
    } catch {
    } finally {
      commit(types.IS_PENDING, false)
    }
  },
}
